import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import Card from "../utils/Card";
import TableScroll from "../utils/TableScroll";
import { Table, TableBody, TableHeader } from "../utils/Table";
import Pagination from "../utils/Pagination";
import { decodeData, errorToaster, formatDate } from "../utils/Helper";
import { useNavigate } from "react-router-dom";
import Input from "../utils/Input";
import Select from "../utils/Select";
import SubmitBtn from "../utils/SubmitBtn";
import DateRangeFormat from "../utils/DateRangeFormat";
import { getMethod } from "../service";
import {
  USER_TRANSACTION_API,
  PAYMENT_PROVIDERS_API,
} from "../service/constant";

const TransactionHistory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [transHistory, setTransHistory] = useState([]);
  const [from, setFrom] = useState(1);
  const [refs, setRefs] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [providers, setProviders] = useState([]);
  const [searchType, setSearchType] = useState("");

  const fetchTransHistory = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await getMethod(
          `${USER_TRANSACTION_API}?page=${page}&limit=50&start_date=${startDate}&end_date=${endDate}&search=${searchId}&type=${searchType}`,
          token.token
        );
        if (res?.isSuccess) {
          setTransHistory(res.data);
          setFrom((res.meta?.current_page - 1) * 50);
          setTotalPage(res.meta?.last_page);
        } else {
          errorToaster("Failed to fetch transactions");
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
        errorToaster("An error occurred while fetching transactions");
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  useEffect(() => {
    fetchTransHistory();
  }, [refs, page]);

  const fetchProviders = async () => {
    const token = decodeData(localStorage.getItem("r_c_a"));
    try {
      const res = await getMethod(`${PAYMENT_PROVIDERS_API}`, token.token);
      if (res?.isSuccess) {
        setProviders(res.data);
      } else {
        errorToaster("Failed to fetch providers");
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      errorToaster("An error occurred while fetching providers");
    }
  };

  useEffect(() => {
    fetchProviders();
  }, []);

  return (
    <Template title={"Transactions History"} isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1">
            <Input
              type="text"
              value={searchId}
              event={(e) => setSearchId(e.target.value)}
              placeholder="Search User Name OR Phone"
            />
          </div>
          <div className="col-12 col-md-4 px-1">
            <Select
              value={searchType}
              event={(e) => setSearchType(e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="bet">Bet</option>
              <option value="bet-win">Bet Win</option>
              <option value="cash-in">Deposit</option>
              <option value="cash-out">Withdraw</option>
              <option value="cash-out-reject">Withdraw Reject</option>
            </Select>
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <DateRangeFormat
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>User Name</th>
              <th>Phone</th>
              <th>Type</th>
              <th>Before</th>
              <th>Amount</th>
              <th>After</th>
              <th>Date & Time</th>
            </TableHeader>
            <TableBody>
              {transHistory.length > 0 &&
                transHistory.map((history, i) => (
                  <tr key={history._id} style={{ verticalAlign: "middle" }}>
                    <td>{i + from + 1}.</td>
                    <td>{history?.userId?.name}</td>
                    <td>{history?.userId?.phone}</td>
                    <td>
                      <span
                        className={`${
                          ["bet", "cash-out"]?.includes(history?.type)
                            ? "text-danger"
                            : "text-success"
                        }`}
                      >
                        {history?.type}
                      </span>
                    </td>
                    <td>{history?.before?.toLocaleString()}</td>
                    <td>
                      <span
                        className={`${
                          ["bet", "cash-out"]?.includes(history?.type)
                            ? "text-danger"
                            : "text-success"
                        }`}
                      >
                        {history?.amount?.toLocaleString()}
                      </span>
                    </td>
                    <td>{history?.after?.toLocaleString()}</td>
                    <td>{formatDate(history.createdAt)}</td>
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
    </Template>
  );
};

export default TransactionHistory;
